import React from 'react';
import './InitiativePartners.css';

const partners = [
    {
        name: 'Bill & Melinda Gates Foundation',
        img: require('../images/billgates.png'), // Save the image as bmgf.png
        alt: 'Bill & Melinda Gates Foundation'
    },
    {
        name: 'GitHub',
        img: require('../images/github.png'), // Save the image as github.png
        alt: 'GitHub'
    },
    {
        name: 'Digital Public Goods Alliance',
        img: require('../images/dpglogo.png'), // Save the image as dpga.png
        alt: 'Digital Public Goods Alliance'
    },
    {
        name: 'Samagra',
        img: require('../images/Samagra.jpg'), // Save the image as samagra.png
        alt: 'Samagra'
    }
];

const InitiativePartners = () => (
    <div className="initiative-partners-section">
        <h2 className="initiative-partners-title">Initiative Partners</h2>
        <div className="initiative-partners-list">
            {partners.map((partner, idx) => (
                <div className="initiative-partner" key={idx}>
                    <img src={partner.img} alt={partner.alt} className="initiative-partner-img" />
                </div>
            ))}
        </div>
    </div>
);

export default InitiativePartners;